import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import { getJobDetail } from 'redux/modules/job-detail/selectors';

import ShipperOrderCard from 'modules/shipper-order/Card';

import { SectionTitleStyled } from 'modules/detail/styled';

import { CardsContainerStyled } from 'modules/detail/styled';

import { isLockedToAgents } from 'modules/locked-to-agents';
import { injectIntl } from 'react-intl';

const ShipperOrders = ({ journey, editOrder, fetching, intl }) => {
  const { shipper_orders_skin, shipper_orders, load_types } = journey || {};
  const t = intl.messages.modules.journey.detail.shipper_order;
  const getShowRemoveButton = useCallback(
    (shipperOrder) => {
      const journeyIsLocked = isLockedToAgents(journey);
      const isShipperOrderInPendingAssignment = ['PENDING_ASSIGNMENT'].includes(
        shipperOrder.status
      );
      const isGroupage = shipper_orders.length > 1;
      const isShipperOrderCancelled = ['CANCELLED'].includes(shipperOrder.status);

      if (isShipperOrderInPendingAssignment && journeyIsLocked) {
        return false;
      }
      return isShipperOrderInPendingAssignment || (isGroupage && !isShipperOrderCancelled);
    },
    [journey, shipper_orders]
  );

  return (
    <>
      <SectionTitleStyled mBottom="S" skin="dark">
        {t.title}
      </SectionTitleStyled>
      <CardsContainerStyled>
        {!fetching &&
          !!journey &&
          shipper_orders.map((shipperOrder, key) => (
            <ShipperOrderCard
              key={key}
              isFrozen={journey?.is_frozen}
              shipperOrder={{ ...shipperOrder, stops: journey.stops }}
              load_types={load_types}
              withinGroupage={shipper_orders.length > 1}
              showHeader
              shipperOrdersSkin={shipper_orders_skin}
              showRemoveButton={getShowRemoveButton(shipperOrder)}
              fullWidth={shipper_orders.length === 1}
              journeyId={journey.id}
              journeyStatus={journey.status}
            />
          ))}
      </CardsContainerStyled>
    </>
  );
};

export default connect((state) => ({
  journey: getJobDetail(state).data,
}))(injectIntl(ShipperOrders));
